<template>
  <div class="card not-word-wrap mb-3">
    <div class="card-body">
      <Loading v-if="showLoading" />
      <div class="row">
        <div class="col-md-6">
          <div class="col-md-10 mb-4">
            <label
              ><label style="color: red; height: 2px;">*</label> نام
              درخواست</label
            >
            <input
              type="text"
              class="form-control border-left-0 browse-file"
              placeholder="نام درخواست"
              v-model="title"
            />
          </div>
          <div class="col-md-10">
            <label>انتخاب فایل شارژ</label>
            <div class="input-group file-browser">
              <input
                type="text"
                class="form-control border-left-0 browse-file"
                id="contract-file"
                placeholder="آپلود فایل"
                readonly=""
              />
              <label class="input-group-btn mb-0">
                <span class="btn btn-primary">
                  انتخاب کنید
                  <input
                    type="file"
                    style="display: none;"
                    accept=".csv"
                    @input="setExcelFile"
                  />
                </span>
              </label>
            </div>

            <p class="mt-3 mb-0">
              <a href="#" @click="(e) => getExcelSample(e)"
                >دریافت فایل نمونه</a
              >
            </p>
          </div>
          <div class="col-md-12 mt-4">
            <p>
              <label style="color: red; height: 2px;">*</label>
              چنانچه مایل به شخصی سازی متن پیامک هستید کادر زیر را کامل کنید
            </p>
          </div>
          <div class="col-md-10 ">
            <div
              class="col-md-12 mt-2 w-2/3"
              style="background-color: bisque; border-radius: 1rem; padding: 1rem;"
            >
              <p style="color: red;">نمونه پیام :</p>
              <p>بانک ایران زمین</p>
              <p>واریز</p>
              <div>
                <span>مشتری عزیز، بابت</span>
                <input
                  class="form-control"
                  placeholder="عملکرد فروردین ماه"
                  style="display: inline; width: 10rem; margin: 0 8px;"
                  v-model="SmsText"
                />
                <span>مبلغ 123،456 ریال به حساب شما واریز شد.</span>
              </div>
              <p class="mt-2">موجودی: 1،409،768 ریال</p>
              <p style="text-align: left;">18:11</p>
              <p style="text-align: left;">1405/01/29</p>
              <!-- <label>متن پیامک</label>
                <textarea class="form-control" v-model="message" /> -->
            </div>
          </div>

          <div class="col-md-12 mt-4">
            <div class="col-md-10  ">
              <button
                class="btn btn-success"
                style="width: 100%; margin-top: 1.5rem; margin-bottom: 1.5rem; padding: 0 1rem; font-size: 1.3rem;"
                v-if="file"
                @click="submit"
              >
                ثبت درخواست
              </button>
            </div>
            <!-- <button
                class="btn btn-primary mr-2"
                v-if="resultFile"
                @click="getResultExcelFile"
              >
                دریافت فایل نتیجه
              </button> -->
          </div>
        </div>
        <div class="col-md-6">
          <p class="text-danger" style="margin-top: 1rem;">
            فایل دانلود شده را با notepad باز کنید یا اگر با اکسل باز میکنید
            حتما ستون کد ملی را از ابتدا به نوع text تغییر دهید و سپس کد ملی را
            وارد کنید.*
          </p>
          <p class="text-danger">
            تعداد مجاز برای هر درخواست 50 هزار ردیف میباشد
          </p>
          <p class="text-danger">حجم فایل نباید بیشتر از 6 مگابایت باشد</p>

          <p class="text-danger">
            مبلغ مجاز برای شارژ 10 هزار تومان تا 50 میلیون تومان میباشد
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Charge",
  data() {
    return {
      resultFile: "",
      showLoading: false,

      nationalCode: "",
      file: "",
      SmsText: "",
      title: "",
    };
  },
  methods: {
    getExcelSample(e) {
      e.preventDefault();
      let a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "https://cardapi.sabinarya.com/api/v1/Jahesh/DownloadSampleCsv",
      );
      let fileName = "Jahesh-charge-sample";
      a.setAttribute("download", fileName);
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
    },
    async toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async setExcelFile(e) {
      const file = e.target.files[0];
      // const finalFile = await this.toBase64(file);
      this.file = file;
      this.resultFile = "";
      document
        .getElementById("contract-file")
        .setAttribute("placeholder", file.name);
    },

    getResultExcelFile() {
      let a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "https://cardapi.sabinarya.com/api/v1/Lookup/download/" +
          this.resultFile,
      );
      let fileName = this.resultFile;
      a.setAttribute("download", fileName);
      window.document.body.appendChild(a);
      a.click();
      window.document.body.removeChild(a);
    },
    submit() {
      if (!this.title.trim()) {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "عنوان درخواست را وارد کنید",
        });
        return;
      }
      this.showLoading = true;
      const formData = new FormData();
      formData.append("File", this.file);
      formData.append("Title", this.title);
      formData.append("SmsText", this.SmsText);
      // let postedData = {
      //   file: this.file,
      //   title: this.title,
      // };

      this.$api
        .post("Jahesh/UploadChargeRequestCsv", formData, {
          headers: { "Content-Type": "mutlipart/form-data" },
        })
        .then(({ data }) => {
          this.resultFile = data.result ? data.result.fileString : "";
          if (data.status)
            this.$swal({
              icon: "success",
              title: "تبریک !",
              text: "ثبت درخواست شارژ با موفقیت انجام شد",
            }).then((res) => {
              if (res.isConfirmed) {
                this.$router.push({ name: "jahesh.chargeList" });
              }
            });
        })
        .finally(() => {
          this.showLoading = false;
        });
    },
  },
};
</script>
